<template>
    <div class="page">
        <sHead></sHead>
        <div class="content">
            <sAside></sAside>
            <el-main>
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
                <!-- 把路由更深一层 相当于所有路由页面 都包含 公共头部组件和侧边导航栏-->
            </el-main>
        </div>
        <Notice :ref="'refNotice' + index" :messageList="[messageList[index]]" v-for="(item, index) in messageList" :key="index"></Notice>
        <!-- <Notice ref="refNotice" :messageList="messageList"></Notice> -->
    </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import sHead from "./sHead"; //引用同目录下得sHead组件
import sAside from "./sAside";
import Notice from "./notice";
import { setShopStorage, getShopStorage } from '../../utils/storage';
export default {
    name: "page",
    data() {
        return {
            messageList: [],
        };
    },
    components: {
        sHead,
        sAside,
        Notice,
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
        this.getRegisterUrlFunc();
        this.getShopList();
        this.getAgencyMessage();
        this.getAllShop();
    },
    methods: {
        ...mapActions({
            getNoticeList: "commodity/getNoticeList",
            getRegisterUrlApi: "loginModule/getRegisterUrlApi",
            shoptypelist: "detect/shoptypelist",
            agencyMessage: "detect/agencyMessage",
            adminApplication: "activity/adminApplication",
            getshopIdName: "newshop/getshopIdName"
        }),
        ...mapMutations({
            setUnreadCount: "setUnreadCount",
            setRegisterUrl: "setRegisterUrl", //设置用户信息
            setAppVerify: "setAppVerify",
        }),
        getAllShop () {
            let shop_list = getShopStorage() || [];
            let shop_status = JSON.parse(localStorage.getItem("shop")) ? JSON.parse(localStorage.getItem("shop")).shop : [];
            if (shop_list.length == shop_status.length) {
                return
            }
            let params = {
                token: this.$store.state.token
            };
            this.getshopIdName(params)
                .then(res => {
                    if (res.code == 1) {
                        setShopStorage(res.data)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
        },
        getApplicationFunc() {
            this.adminApplication({ token: this.getToken }).then(({ data }) => {
                if (data.code == 1) {
                    this.setAppVerify(data.data.list);
                }
            });
        },
        getAgencyMessage() {
            this.agencyMessage({ token: this.getToken, is_read: 1 }).then(({ data }) => {
                if (data.code == 1) {
                    if (data.data.notice && data.data.notice.length > 0) {
                        this.messageList = data.data.notice;
                        this.messageList.forEach((item, index) => {
                            this.$nextTick(() => {
                                this.$refs["refNotice" + index][0].dialogVisible = true;
                            });
                        });
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        getShopList() {
            this.shoptypelist({ token: this.getToken }).then(({ data }) => {
                if (data.code == 1) {
                    localStorage.setItem("shop", JSON.stringify(data.data));
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        getRegisterUrlFunc() {
            this.getRegisterUrlApi({ token: this.getToken }).then((res) => {
                if (res.data.code == 1) {
                    this.registerUrl = res.data.data.url;
                    this.setRegisterUrl(res.data.data.url);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        getList(val) {
            this.load = true;
            let opt = {
                token: this.getToken,
                type: 1, //消息类型，1-审核消息
                page_size: 10, //页大小
                page: 1, //页数
            };
            this.getNoticeList(opt).then((res) => {
                this.load = false;
                // console.log(res);
                if (res.code == 1) {
                    this.setUnreadCount(res.data.unread_count ? res.data.unread_count : 0);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.page {
    .content {
        display: flex;
        .el-main {
            height: calc(100vh - 64px);
            overflow-y: auto;
            background: #f0f2f5;
            padding: 0;
        }
    }
}
</style>